import { Helmet } from 'react-helmet';
import MobifoneNapLeDetail
  from 'src/components/MobifoneNapLe-detail/MobifoneNapLeDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

//import MobifoneNapLeToolbar from '../components/MobifoneNapLe-detail/MobifoneNapLeToolbar';

const MobifoneNapLe = () => (
  <>
    <Helmet>
      <title>Mobifone - Nạp lẻ</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "500px", width: "100%"}}>
        {/* <MobifoneNapLeToolbar /> */}
        <Box sx={{ pt: 3 }}>
          <MobifoneNapLeDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default MobifoneNapLe;
